import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import './Everythingwin.css'
import Img from '../images/buddles/sideformimage.png'

gsap.registerPlugin(ScrollTrigger)

function Everythingwin() {
  const sectionRef = useRef(null)
  const topRowRef = useRef(null)
  const arenaRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 78%',
          once: true,
        },
        defaults: { ease: 'power3.out' },
      })

      tl.from(topRowRef.current.children, {
        opacity: 0,
        y: 24,
        duration: 0.65,
        stagger: 0.1,
      }).from(
        arenaRef.current,
        {
          opacity: 0,
          y: 28,
          scale: 0.98,
          duration: 0.7,
        },
        '-=0.2'
      )
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section className="everything-win-section" ref={sectionRef}>
      <div className="everything-win-container" ref={topRowRef}>
        <div className="vault-image-box">
          <img src={Img} alt="Collector cards" />
        </div>

        <div className="vault-content">
          <span className="vault-badge">Everything You Win</span>

          <h2>THE VAULT</h2>

          <p>
            The Vault is your personal collector dashboard — where every win,
            purchase, and auction victory is stored, tracked, and managed. No
            chaos. No lost items. Just clean, powerful control panel for serious
            collectors.
          </p>

          <ul>
            <li>Order & win history</li>
            <li>Watchlist tracking</li>
            <li>Shipping + shipping holds</li>
            <li>Payment method management</li>
            <li>Weekly bundle control</li>
          </ul>

          <div className="vault-buttons">
            <button>Enter Your Vault</button>
            <button className="outline-btn">View Collection History</button>
          </div>
        </div>
      </div>

      <div className="arena-content" ref={arenaRef}>
        <h1>STEP INTO THE ARENA</h1>
        <p>
          Join a new era of collectibles where every card drop has energy, every
          auction has tension, and every win feels earned. This is not a
          marketplace. <br />
          This is CBC.
        </p>
      </div>
    </section>
  )
}

export default Everythingwin
